import AppConfig from '@/app.config.js'
import router from '@/router.js'

//import api from "@/services/apiService"

import firebase from 'firebase/app'
import 'firebase/auth'

class AuthService {

  saveLogin(loginResult) {
    return new Promise(async (resolve) => {
      await localStorage.setItem(AppConfig.auth.isLoggedIn, 'true');
      await localStorage.setItem(AppConfig.auth.accessToken, loginResult.accessToken);
      await localStorage.setItem(AppConfig.auth.userRole, loginResult.role);
      resolve(true);
    });
  }

  isLoggedIn() {
    return localStorage.getItem(AppConfig.auth.isLoggedIn) === 'true';
  }

  async logout() {
    await localStorage.removeItem(AppConfig.auth.isLoggedIn)
    await localStorage.removeItem(AppConfig.auth.accessToken)
    await localStorage.removeItem(AppConfig.auth.userRole)
    await firebase.auth().signOut()
    router.push({name: 'auth-login'})
  }

  getProfile() {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged(function(user) {
        //console.log('user', user)
        if (user) {
          // User is signed in.
          firebase
          .auth()
          .currentUser
          .getIdToken(true)
          .then(async (idToken)=>{
            //console.log('idToken', idToken)
            await localStorage.setItem(AppConfig.auth.accessToken, idToken)
            //console.log('user', user)
            resolve({
              fullname: user.displayName,
              username: user.email,
              role: 'Admin',
              img: user.photoURL
            })
          })
        } else {
          // No user is signed in.
          console.log('No user is signed in.')
          logout()
          reject(null)
        }
      });
    });

  }

}

export default new AuthService();
